import React, { useCallback, useEffect, useState } from "react";
import LandingFooter from "../part/landing.footer";
import DescribeBody from "../part/user/description.body";
import DescribeCourse from "../part/user/course_description";
import RelatedVideo from "../part/user/related_videos";
import CourseVideo from "../part/user/course_video";
import DocumentCourse from "../part/user/course_description_document";
import IncludeCourse from "../part/user/course.include";
import CourseProcedure from "../part/user/course.procedure";
import { useParams } from "react-router-dom";
import Image1 from "../image/tope.jpg";
import LandingSearchHeader from "../part/header_search";
import FloatingContact from "../part/floating.contact";
import FooterRight from "../part/landing.footer.right";
import CourseReview from "../part/user/course.review";
import LoadingError from "../part/loading_error";
import NetworkIssue from "../part/network";
import axios from "axios";
import MapComponent from "../part/location.map";
import AssignmentCourse from "../part/user/course_assignment";
import { IoMdLock } from "react-icons/io";
import UserExamSection from "../part/user/user_exam_list";
import CourseSchema from "./CourseSchema";

const LandingCourseDescription = () => {
  const { course_id, course_name } = useParams();
  const [loading, setLoading] = useState(true);
  const [network, setNetwork] = useState(false);
  const [section, setSection] = useState("overview");
  const [courses, setCourses] = useState([]);

  // === Error message state (shows and disappears after 4s) ===
  // const [showError, setShowError] = useState(false);
  // const errorTimerRef = useRef(null);

  // const handleLockedClick = () => {
  //   setShowError(true);

  //   if (errorTimerRef.current) {
  //     clearTimeout(errorTimerRef.current);
  //   }

  //   errorTimerRef.current = setTimeout(() => {
  //     setShowError(false);
  //     errorTimerRef.current = null;
  //   }, 4000);
  // };

  // useEffect(() => {
  //   return () => {
  //     if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
  //   };
  // }, []);

  const handleSectionChange = (value) => {
    setSection(value);
  };

  const fetchData = useCallback(async () => {
    const courseId = parseInt(course_id, 10);
    const accessToken = localStorage.getItem("accessToken");

    let headers = {};
    if (accessToken) {
      headers = {
        Authorization: `Bearer ${accessToken}`,
      };
    }

    try {
      const response = await axios.get(
        `https://api.geoinfoacademy.com/api/courses/${courseId}`,
        { headers }
      );
      setCourses(response.data);
      setLoading(false);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        window.location.href = "/";
      } else if (error.code === "ERR_NETWORK") {
        setNetwork(true);
        setLoading(false);
      } else {
        console.error("Error fetching course:", error);
        setLoading(false);
      }
    }
  }, [course_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="body landing">
      <LandingSearchHeader />
      <DescribeBody
        course_id={course_id}
        course={courses}
        fetchcourse={fetchData}
      />

      <div className="description_information">
        <nav className="description_filter">
          <button
            className={section === "overview" ? "active" : null}
            onClick={() => handleSectionChange("overview")}
          >
            Overview
          </button>
          <button
            className={section === "material" ? "active" : null}
            onClick={() => handleSectionChange("material")}
          // courses.enrolled
          //   ? 
          //   : handleLockedClick

          >
            Training Materials{" "}
            {courses.enrolled ? null : (
              <IoMdLock style={{ marginLeft: "10px" }} />
            )}
          </button>
        </nav>

        {section === "overview" && (
          <>
            <DescribeCourse course_id={course_id} course={courses} />
            <CourseProcedure course_id={course_id} course={courses} />
            <IncludeCourse course_id={course_id} course={courses} />
            {courses.training_type !== "Online Prerecorded" &&
              courses.training_type !== "Online Live with Facilitator" ? (
              <section className="descript_include" style={{ marginTop: "30px" }}>
                <MapComponent />
              </section>
            ) : null}
            <CourseReview course_id={course_id} course={courses} />
            <RelatedVideo course_id={course_id} course={courses}  />
            <section className="course_instructor">
              <h3>Instructor</h3>
              <div className="image">
                <img src={Image1} alt="CEO" />
              </div>
              <div className="about">
                <h4>
                  Mr Tope <br />
                  <span>CEO at Geoinfotech</span>{" "}
                </h4>
              </div>
            </section>
          </>
        )}

        {section === "material" && (
          <>
            <CourseVideo course_id={course_id} course={courses} />
            <DocumentCourse course_id={course_id} course={courses} />
            <AssignmentCourse course_id={course_id} />
            <UserExamSection course_id={course_id} course={courses} width={"width"} course_name={course_name}/>
            
          </>
        )}
      </div>

      {/* Error message display */}
      {/* {showError && (
        <div className="error-message">
          <p>You need to enroll to access training materials.</p>
        </div>
      )} */}

      <FloatingContact />
      <LandingFooter />
      <FooterRight />
      {loading ? <LoadingError /> : null}
      {network ? <NetworkIssue /> : null}
      <CourseSchema
        name= {courses.title}
        description={courses.description}
        url={`https://geoinfoacademy.com/Landing_description/${courses.id}/${courses.title}`}
      />
    </div>
  );
};

export default LandingCourseDescription;
